/* eslint-disable no-typeof-window-undefined/no-typeof-window-undefined */
/**
 * @returns {boolean} - whether running in a browser environment
 */
export const isClient = (): boolean =>
  typeof window !== 'undefined' && typeof document !== 'undefined';
